export const CONTACT_EMAIL = "contact@uniqly.io";

export const CONTACT_UNIQLY_EMAIL = "contact@uniqly.io";

export const CONTACT_JAKE_EMAIL = "Jake@uniqly.io";

export const INTERNAL_ERRORS_EMAIL = "mateusz.chrzanowski@uniqly.io";

export const MODEL_BACKGROUND = "#ECEAEA";
